
import type { SetupContext } from 'vue'
import type Vue from 'vue'
import type { ExplainSections } from '../../../models/views/explain'
import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
import { useExplainBrowse } from '../../../composables/explain/use-explain-browse'
import { ExplainSectionEnum } from '../../../enums'
import { EpbButton } from '../../shared'

export default defineComponent({
  name: 'ExplainSectionSelector',
  components: {
    EpbButton,
  },
  setup: (props, ctx: SetupContext) => {
    const { emit } = ctx
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }
    const baseClass = 'epb-explain-section-selector'
    const messages = $epb.messages.explain.sections

    const { isBrowseContext } = useExplainBrowse()

    const sections = computed<ExplainSections[]>(() => [
      {
        id: ExplainSectionEnum.SEARCH,
        icon: 'query',
      },
      ...(!isBrowseContext.value
        ? [
            {
              id: ExplainSectionEnum.QUERY_ANALYSIS,
              icon: 'comment',
            },
          ]
        : []),
    ])

    const selectedSection = ref<string>(ExplainSectionEnum.SEARCH)
    const updateSection = (sectionId: string): void => {
      selectedSection.value = sectionId
      emit('update-section', sectionId)
    }

    const isSectionSelected = (sectionId: string): boolean => {
      return selectedSection.value === sectionId
    }

    const getSectionLabel = (sectionId: string): string =>
      sectionId === ExplainSectionEnum.SEARCH && isBrowseContext.value
        ? messages[sectionId].browseLabel
        : messages[sectionId].label

    return {
      baseClass,
      messages,
      isSectionSelected,
      sections,
      selectedSection,
      updateSection,
      getSectionLabel,
    }
  },
})
